import useGetSubadmins from './useGetSubadmins'

export default useGetSubadmins
